module.exports = __webpack_public_path__ + "img/gopay.35278988.png";